/**
 * 购物车错误提示信息
 */
class CartErrorMessage extends LoadingAnimation {
  constructor() {
    super();
  }
  
  setContent(message) {
    this.querySelector('[data-message]').innerHTML = message;
    this.setTimeOutHide();
  }
  
  setTimeOutHide(time = 4000) {
    const timer =  setTimeout(() => {
      this.hide();
      clearTimeout(timer);
    }, time)
  }
}

customElements.define('cart-error-message', CartErrorMessage);
